import { CircularProgressProps } from '@material-ui/core';

export const circularProgress: CircularProgressProps = {
  color: 'primary',
};
